export const HOSPITAL_RECEIPT_TEMPLATE_MAPPING = {
  13: 'dsmc', // 계명대학교 동산의료원
  15: 'hallym-chuncheon', // 한림대학교 춘천성심병원
  16: 'hallym-pyeongchon', // 한림대학교 평촌성심병원
  21: 'hallym-dongtan', // 한림대학교 동탄성심병원
  26: 'hallym-gangnam', // 한림대학교 강남성심병원
};
export const getReceiptTemplateByHspId = (hspId) => {
  if (isNaN(hspId)) return;

  return HOSPITAL_RECEIPT_TEMPLATE_MAPPING[Number(hspId)] || 'hallym-chuncheon';
};
